import service from '@/store/services/workshop/business_unit-service';

const state = {
  list: {},
  business_unit: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, business_unit) => {
    state.business_unit = business_unit;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((business_unit) => { commit('SET_RESOURCE', business_unit); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((business_unit) => { commit('SET_RESOURCE', business_unit); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((business_unit) => { commit('SET_RESOURCE', business_unit); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((business_unit) => { commit('SET_RESOURCE', business_unit); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  business_unit: state => state.business_unit,
};
 
const business_unit = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default business_unit;
